(function () {
  function setupDesktopMenu() {
    var nav = document.querySelector('[data-kn-desktop-menu]');
    var backdrop = document.querySelector('[data-kn-desktop-menu-backdrop]');
    if (!nav || !backdrop || nav.dataset.knDesktopMenuReady) return;
    nav.dataset.knDesktopMenuReady = 'true';

    var items = Array.from(nav.querySelectorAll('[data-kn-desktop-menu-item]'));
    var desktop = window.matchMedia('(min-width: 1200px)');
    var activeItem = null;
    var closeTimer = null;

    nav.querySelectorAll('[data-kn-photo-menu]').forEach(function (photoMenu) {
      var options = Array.from(photoMenu.querySelectorAll('[data-kn-photo-option]'));
      var stage = photoMenu.querySelector('[data-kn-photo-stage]');
      var name = photoMenu.querySelector('[data-kn-photo-preview-name]');
      var comparison = photoMenu.querySelector('[data-kn-photo-preview-comparison]');
      if (!stage || !name || !comparison) return;

      function parsePhotoSize(label) {
        var inches = label.match(/^\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if (inches) return [Number(inches[1]), Number(inches[2])];
        var centimetres = label.match(/\(?~?\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if (centimetres) return [Number(centimetres[1]) / 2.54, Number(centimetres[2]) / 2.54];
        return null;
      }

      function showPhotoOption(option) {
        var sheetType = option.dataset.knPhotoSheet;
        var sizeName = option.querySelector('.kn-menu-size-label__primary')?.textContent.trim() || option.dataset.knPhotoLabel.split(' (')[0];
        var comparisonText = option.dataset.knPhotoDetail || '';
        if (sheetType) {
          stage.dataset.photoType = sheetType;
          stage.setAttribute('aria-label', sizeName + '. Repeated portrait photos arranged on a print sheet.');
          name.textContent = sizeName;
          comparison.textContent = comparisonText;
          return;
        }
        var dimensions = parsePhotoSize(option.dataset.knPhotoLabel || '');
        if (!dimensions) return;
        var width = Math.min(dimensions[0], dimensions[1]);
        var height = Math.max(dimensions[0], dimensions[1]);
        stage.dataset.photoType = 'print';
        var scale = Math.min(19, 320 / width, 400 / height);
        stage.style.setProperty('--kn-photo-width', width * scale + 'px');
        stage.style.setProperty('--kn-photo-height', height * scale + 'px');
        stage.setAttribute('aria-label', sizeName + ' photo print. ' + comparisonText);
        name.textContent = sizeName;
        comparison.textContent = comparisonText;
      }

      options.forEach(function (option) {
        option.addEventListener('pointerenter', function () { showPhotoOption(option); });
        option.addEventListener('focusin', function () { showPhotoOption(option); });
      });
      var initial = options.find(function (option) { return /^\s*12\s*[x×]\s*18\b/i.test(option.dataset.knPhotoLabel || ''); });
      if (initial || options.length) showPhotoOption(initial || options[0]);
    });

    nav.querySelectorAll('[data-kn-canvas-menu]').forEach(function (canvasMenu) {
      var options = Array.from(canvasMenu.querySelectorAll('[data-kn-canvas-option]'));
      var stage = canvasMenu.querySelector('[data-kn-canvas-stage]');
      var legends = Array.from(canvasMenu.querySelectorAll('[data-kn-canvas-legend]'));
      var name = canvasMenu.querySelector('[data-kn-canvas-preview-name]');
      var detail = canvasMenu.querySelector('[data-kn-canvas-preview-detail]');
      var note = canvasMenu.querySelector('[data-kn-canvas-note]');
      if (!stage || !name || !detail) return;

      function showCanvasOption(option) {
        var title = option.dataset.knCanvasTitle || '';
        var description = option.dataset.knCanvasDetail || '';
        var shape = option.dataset.knCanvasShape || 'standard';
        stage.dataset.shape = shape;
        legends.forEach(function (legend) {
          legend.hidden = legend.dataset.knCanvasLegend !== (shape === 'stretched' ? 'stretched' : shape === 'standard' ? 'standard' : 'added');
        });
        stage.setAttribute('aria-label', title + (shape === 'stretched' ? ' gallery wrap example' : ' canvas shape illustration'));
        name.textContent = title;
        detail.textContent = description;
        if (note) note.hidden = shape === 'stretched';
        options.forEach(function (current) {
          current.classList.toggle('is-preview-active', current === option);
        });
      }

      options.forEach(function (option) {
        option.addEventListener('pointerenter', function () { showCanvasOption(option); });
        option.addEventListener('focusin', function () { showCanvasOption(option); });
      });
      if (options.length) showCanvasOption(options[0]);
    });

    nav.querySelectorAll('[data-kn-memoroids-menu]').forEach(function (memoroidsMenu) {
      var options = Array.from(memoroidsMenu.querySelectorAll('[data-kn-memoroids-option]'));
      var preview = memoroidsMenu.querySelector('[data-kn-memoroids-preview]');
      var name = memoroidsMenu.querySelector('[data-kn-memoroids-preview-name]');
      var size = memoroidsMenu.querySelector('[data-kn-memoroids-preview-size]');
      var stage = memoroidsMenu.querySelector('[data-kn-memoroids-stage]');
      if (!preview || !name || !size || !stage) return;

      function showMemoroid(option) {
        var shape = option.dataset.knMemoroidsShape || 'mini';
        var label = option.dataset.knMemoroidsName || '';
        var dimensions = option.dataset.knMemoroidsSize || '';
        stage.dataset.shape = shape;
        name.textContent = label;
        size.textContent = dimensions;
        options.forEach(function (current) {
          current.classList.toggle('is-preview-active', current === option);
        });
      }

      options.forEach(function (option) {
        option.addEventListener('pointerenter', function () { showMemoroid(option); });
        option.addEventListener('focusin', function () { showMemoroid(option); });
      });
      if (options.length) showMemoroid(options[0]);
    });

    function cancelClose() {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        openItem(null);
      }, 250);
    }

    function positionPanel() {
      var headerMiddle = nav.closest('.ltn__header-area')?.querySelector('.ltn__header-middle-area');
      if (!headerMiddle) return;
      document.documentElement.style.setProperty('--kn-desktop-menu-bridge-top', Math.max(0, Math.floor(nav.getBoundingClientRect().bottom) - 1) + 'px');
      document.documentElement.style.setProperty('--kn-desktop-menu-top', Math.max(0, Math.round(headerMiddle.getBoundingClientRect().bottom)) + 'px');
    }

    function openItem(item) {
      if (!desktop.matches) item = null;
      cancelClose();
      activeItem = item;
      if (item) positionPanel();
      items.forEach(function (current) {
        var isOpen = current === item;
        current.classList.toggle('is-open', isOpen);
        current.querySelector('.kn-desktop-nav__trigger')?.setAttribute('aria-expanded', String(isOpen));
        var panel = current.querySelector('[data-kn-desktop-menu-panel]');
        if (panel) panel.inert = !isOpen;
      });
      document.body.classList.toggle('kn-desktop-menu-open', !!item);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.kn-desktop-nav__trigger');
      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') openItem(item);
      });
      item.querySelector('[data-kn-desktop-menu-panel]')?.addEventListener('pointerenter', cancelClose);
      item.addEventListener('focusin', function () { openItem(item); });
      trigger.addEventListener('click', function (event) {
        if (trigger.getAttribute('href') === '#') {
          event.preventDefault();
          openItem(item);
          return;
        }
        if (!desktop.matches || !window.matchMedia('(hover: none)').matches || activeItem === item) return;
        event.preventDefault();
        openItem(item);
      });
    });

    nav.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'touch') scheduleClose();
    });
    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) openItem(null);
    });
    backdrop.addEventListener('click', function () { openItem(null); });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !activeItem) return;
      var trigger = activeItem.querySelector('.kn-desktop-nav__trigger');
      if (trigger) trigger.focus();
      openItem(null);
    });
    window.addEventListener('scroll', function () { if (activeItem) requestAnimationFrame(positionPanel); }, { passive: true });
    window.addEventListener('resize', function () { if (activeItem) positionPanel(); });
    desktop.addEventListener('change', function () { openItem(null); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDesktopMenu, { once: true });
  } else {
    setupDesktopMenu();
  }
  document.addEventListener('shopify:section:load', setupDesktopMenu);
})();
